import '@lauragaistourisme/scss/app-tourism.scss';
import WpetList from '@lauragaistourisme/js/wpet/list';
import WpetSingle from '@lauragaistourisme/js/wpet/single';
import WpetCrossSelling from '@lauragaistourisme/js/wpet/cross_selling';
//import { WpetInteractiveMap } from '@lauragaistourisme/js/components/wpet_interactive_map';

document.addEventListener("DOMContentLoaded", function () {
    new WpetList();
    new WpetSingle();
    new WpetCrossSelling();
    //const ObjWpetInteractiveMap   = new WpetInteractiveMap();
});
